import React, { useEffect, useRef, useState } from 'react';
import datacoLogo from '../../Assets/dataco_logo-NEW.png';
import {
    COMPLETE_PROGRESS,
    COMPLETION_HOLD_MS,
    INITIAL_PROGRESS,
    PROGRESS_INTERVAL_MS,
    getNextProgress,
} from './progress';
import './DatacoLoadingIndicator.css';

export default function DatacoLoadingIndicator({
    loading = true,
    variant = 'inline',
    size = 'standard',
    label = 'Loading',
    className = '',
}) {
    const [progress, setProgress] = useState(INITIAL_PROGRESS);
    const [visible, setVisible] = useState(Boolean(loading));
    const intervalRef = useRef(null);
    const completionRef = useRef(null);

    useEffect(() => {
        clearInterval(intervalRef.current);
        clearTimeout(completionRef.current);

        if (loading) {
            setVisible(true);
            setProgress(INITIAL_PROGRESS);
            intervalRef.current = setInterval(() => {
                setProgress((current) => getNextProgress(current));
            }, PROGRESS_INTERVAL_MS);
        } else if (visible) {
            setProgress(COMPLETE_PROGRESS);
            completionRef.current = setTimeout(() => {
                setVisible(false);
            }, COMPLETION_HOLD_MS);
        }

        return () => {
            clearInterval(intervalRef.current);
            clearTimeout(completionRef.current);
        };
    }, [loading]);

    if (!visible) return null;

    const classes = [
        'dataco-loading-indicator',
        `dataco-loading-indicator--${variant}`,
        `dataco-loading-indicator--${size}`,
        className,
    ].filter(Boolean).join(' ');

    return (
        <div className={classes} role="status" aria-live="polite" aria-busy={visible}>
            <div className="dataco-loading-indicator__logo-wrap" aria-hidden="true">
                <img
                    className="dataco-loading-indicator__logo dataco-loading-indicator__logo--grayscale"
                    src={datacoLogo}
                    alt=""
                />
                <img
                    className="dataco-loading-indicator__logo dataco-loading-indicator__logo--color"
                    src={datacoLogo}
                    alt=""
                    style={{ clipPath: `inset(0 0 ${100 - progress}% 0)` }}
                />
            </div>
            <div className="dataco-loading-indicator__percentage">{progress}%</div>
            <span className="visually-hidden">{label}</span>
        </div>
    );
}
